import { fontSizes, fontWeights } from "@gumtree/ui-library/src/base/theme";

export const NavBarButtonOverride = `
    padding: 0;
    font-size: ${fontSizes.smaller};
    font-weight: ${fontWeights.normal};
    transition: 0.1s ease;
`;
